import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './output.css';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import {enableMapSet} from "immer";

import App from './App';
import Dashboard from './dashboard';
import Clients from './clients';
import AddClient from './clientadd';
import ReviewsQueue from './reviewsqueue';
import ReviewQueue from './reviewqueue';
import Admin from './admin';
import LocationManage from './locationmanage';
import Coaches from './coaches';
import Locations from './locations';
import Partners from './partners';
import Programs from './programs';
import Settings from './settings';
import LocationPrograms from './location-programs';
import CheckIns from './check-ins';
import UpdatePassword from './UpdatePassword';


// Immer enableMapSet
enableMapSet()

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />
  },
  {
    path: "/clients",
    element: <Clients />
  },
  {
    path: "/clients/add",
    element: <AddClient />
  },
  {
    path: "/reviews",
    element: <ReviewsQueue />
  },
  {
    path: "/reviews/queue",
    element: <ReviewQueue />
  },
  {
    path: "/admin",
    element: <Admin />
  },
  {
    path: "/location/:id",
    element: <LocationManage />
  },
  {
    path: "/coaches",
    element: <Coaches />
  },
  {
    path: "/locations",
    element: <Locations />
  },
  {
    path: "/partners",
    element: <Partners />
  },
  {
    path: "/programs",
    element: <Programs />
  },
  {
    path: "/settings",
    element: <Settings />
  },
  {
    path: "/location-programs",
    element: <LocationPrograms />
  },
  {
    path: "/check-ins",
    element: <CheckIns />
  },
  {
    path: "/update-password",
    element: <UpdatePassword />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
